import type { FaqDefinition, FaqVisibilityRules } from '~/features/my-wallet/types/faq'

export type ReceivingModelFaqVisibility = 'always' | 'except_essential_profile' | 'commercial_exception_only'

export interface ReceivingModelFaqContext {
  isEssentialProfile: boolean
  hasCommercialException: boolean
}

export const RECEIVING_MODEL_FAQ_KEY_PATH = 'my_wallet.faq.items'

export const RECEIVING_MODEL_FAQ: FaqDefinition<ReceivingModelFaqVisibility>[] = [
  { key: 'what_are_models', visibility: 'always' },
  { key: 'everyone_starts_at_c', visibility: 'except_essential_profile' },
  { key: 'how_to_be_eligible_ab', visibility: 'except_essential_profile' },
  { key: 'how_is_percentage_calculated', visibility: 'except_essential_profile' },
  { key: 'model_ranges', visibility: 'except_essential_profile' },
  { key: 'why_only_a_requires_delinquency', visibility: 'except_essential_profile' },
  { key: 'can_i_lose_model', visibility: 'except_essential_profile' },
  { key: 'when_is_performance_evaluated', visibility: 'except_essential_profile' },
  { key: 'why_still_model_c', visibility: 'except_essential_profile' },
  { key: 'delinquency_warning', visibility: 'except_essential_profile' },
  { key: 'delinquency_critical', visibility: 'except_essential_profile' },
  { key: 'why_all_blocked', visibility: 'always' },
  { key: 'essential_profile_models', visibility: 'always' },
  { key: 'what_is_commercial_exception', visibility: 'commercial_exception_only' },
  { key: 'what_counts_as_on_time', visibility: 'except_essential_profile' },
  { key: 'why_different_deadlines', visibility: 'except_essential_profile' },
  { key: 'do_kits_count_together', visibility: 'except_essential_profile' },
  { key: 'data_update_frequency', visibility: 'except_essential_profile' },
]

export const RECEIVING_MODEL_FAQ_VISIBILITY: FaqVisibilityRules<ReceivingModelFaqVisibility, ReceivingModelFaqContext> = {
  always: () => true,
  except_essential_profile: context => !context.isEssentialProfile,
  commercial_exception_only: context => context.hasCommercialException,
}
